module.exports = __webpack_public_path__ + "static/media/img-box-default.29c19010.png";